// Application constants
import { useNavigate } from 'react-router'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api'

export const NORMAL_LOGIN_FLOW = 'normal_login' // By username ,password

export const getValidCriteria = criteria =>
  criteria && criteria.some(c => c.value || c.searchValueList || c.operator == "IS_NULL" || c.operator == "IS_NOT_NULL") ? criteria : []

export const DEFAULT_PAGE = 500000


export const COUNTRY_LIST = [
  { id: "AFGHANISTAN", label: "AFGHANISTAN", value: "AFGHANISTAN" },
  { id: "AKROTIRI", label: "AKROTIRI", value: "AKROTIRI" },
  { id: "ALBANIA", label: "ALBANIA", value: "ALBANIA" },
  { id: "ALGERIA", label: "ALGERIA", value: "ALGERIA" },
  { id: "AMERICAN SAMOA", label: "AMERICAN SAMOA", value: "AMERICAN SAMOA" },
  { id: "ANDORRA", label: "ANDORRA", value: "ANDORRA" },
  { id: "ANGOLA", label: "ANGOLA", value: "ANGOLA" },
  { id: "ANGUILLA", label: "ANGUILLA", value: "ANGUILLA" },
  { id: "ANTARCTICA", label: "ANTARCTICA", value: "ANTARCTICA" },
  { id: "ANTIGUA AND BARBUDA", label: "ANTIGUA AND BARBUDA", value: "ANTIGUA AND BARBUDA" },
  { id: "ARGENTINA", label: "ARGENTINA", value: "ARGENTINA" },
  { id: "ARMENIA", label: "ARMENIA", value: "ARMENIA" },
  { id: "ARUBA", label: "ARUBA", value: "ARUBA" },
  { id: "ASHMORE AND CARTIER ISLANDS", label: "ASHMORE AND CARTIER ISLANDS", value: "ASHMORE AND CARTIER ISLANDS" },
  { id: "AUSTRALIA", label: "AUSTRALIA", value: "AUSTRALIA" },
  { id: "AUSTRIA", label: "AUSTRIA", value: "AUSTRIA" },
  { id: "AZERBAIJAN", label: "AZERBAIJAN", value: "AZERBAIJAN" },
  { id: "BAHRAIN", label: "BAHRAIN", value: "BAHRAIN" },
  { id: "BAILIWICK OF GUERNSEY", label: "BAILIWICK OF GUERNSEY", value: "BAILIWICK OF GUERNSEY" },
  { id: "BAILIWICK OF JERSEY", label: "BAILIWICK OF JERSEY", value: "BAILIWICK OF JERSEY" },
  { id: "BAKER ISLAND", label: "BAKER ISLAND", value: "BAKER ISLAND" },
  { id: "BANGLADESH", label: "BANGLADESH", value: "BANGLADESH" },
  { id: "BARBADOS", label: "BARBADOS", value: "BARBADOS" },
  { id: "BELARUS", label: "BELARUS", value: "BELARUS" },
  { id: "BELGIUM", label: "BELGIUM", value: "BELGIUM" },
  { id: "BELIZE", label: "BELIZE", value: "BELIZE" },
  { id: "BENIN PORTO", label: "BENIN PORTO", value: "BENIN PORTO" },
  { id: "BERMUDA", label: "BERMUDA", value: "BERMUDA" },
  { id: "BHUTAN", label: "BHUTAN", value: "BHUTAN" },
  { id: "BOLIVIA", label: "BOLIVIA", value: "BOLIVIA" },
  { id: "BOSNIAAND HERZEGOVINA", label: "BOSNIAAND HERZEGOVINA", value: "BOSNIAAND HERZEGOVINA" },
  { id: "BOTSWANA", label: "BOTSWANA", value: "BOTSWANA" },
  { id: "BOUVET ISLAND", label: "BOUVET ISLAND", value: "BOUVET ISLAND" },
  { id: "BRAZIL", label: "BRAZIL", value: "BRAZIL" },
  { id: "BRITISH INDIAN OCEAN TERRITORY", label: "BRITISH INDIAN OCEAN TERRITORY", value: "BRITISH INDIAN OCEAN TERRITORY" },
  { id: "BRUNEI", label: "BRUNEI", value: "BRUNEI" },
  { id: "BULGARIA", label: "BULGARIA", value: "BULGARIA" },
  { id: "BURKINA FASO", label: "BURKINA FASO", value: "BURKINA FASO" },
  { id: "BURUNDI", label: "BURUNDI", value: "BURUNDI" },
  { id: "CAMBODIA", label: "CAMBODIA", value: "CAMBODIA" },
  { id: "CAMEROON", label: "CAMEROON", value: "CAMEROON" },
  { id: "CANADA", label: "CANADA", value: "CANADA" },
  { id: "CAPE VERDE", label: "CAPE VERDE", value: "CAPE VERDE" },
  { id: "CAYMAN ISLANDS", label: "CAYMAN ISLANDS", value: "CAYMAN ISLANDS" },
  { id: "CENTRAL AFRICAN REPUBLIC", label: "CENTRAL AFRICAN REPUBLIC", value: "CENTRAL AFRICAN REPUBLIC" },
  { id: "CHAD", label: "CHAD", value: "CHAD" },
  { id: "CHILE", label: "CHILE", value: "CHILE" },
  { id: "CHINA", label: "CHINA", value: "CHINA" },
  { id: "CHRISTMAS ISLAND", label: "CHRISTMAS ISLAND", value: "CHRISTMAS ISLAND" },
  { id: "CLIPPERTON ISLAND", label: "CLIPPERTON ISLAND", value: "CLIPPERTON ISLAND" },
  { id: "COCOS (KEELING) ISLANDS", label: "COCOS (KEELING) ISLANDS", value: "COCOS (KEELING) ISLANDS" },
  { id: "COLOMBIA", label: "COLOMBIA", value: "COLOMBIA" },
  { id: "COMMONWEALTH OF PUERTO RICO", label: "COMMONWEALTH OF PUERTO RICO", value: "COMMONWEALTH OF PUERTO RICO" },
  { id: "COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS", label: "COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS", value: "COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS" },
  { id: "COMOROS", label: "COMOROS", value: "COMOROS" },
  { id: "CONGO,DEMOCRATIC REPUBLIC OF THE", label: "CONGO,DEMOCRATIC REPUBLIC OF THE", value: "CONGO,DEMOCRATIC REPUBLIC OF THE" },
  { id: "CONGO,REPUBLIC OF THE", label: "CONGO,REPUBLIC OF THE", value: "CONGO,REPUBLIC OF THE" },
  { id: "COOK ISLANDS", label: "COOK ISLANDS", value: "COOK ISLANDS" },
  { id: "CORAL SEA ISLANDS", label: "CORAL SEA ISLANDS", value: "CORAL SEA ISLANDS" },
  { id: "CORAL SEA ISLANDS TERRITORY", label: "CORAL SEA ISLANDS TERRITORY", value: "CORAL SEA ISLANDS TERRITORY" },
  { id: "COSTA RICA", label: "COSTA RICA", value: "COSTA RICA" },
  { id: "COTE D'IVOIRE", label: "COTE D'IVOIRE", value: "COTE D'IVOIRE" },
  { id: "CROATIA", label: "CROATIA", value: "CROATIA" },
  { id: "CUBA", label: "CUBA", value: "CUBA" },
  { id: "CYPRUS", label: "CYPRUS", value: "CYPRUS" },
  { id: "CZECH REPUBLIC", label: "CZECH REPUBLIC", value: "CZECH REPUBLIC" },
  { id: "DENMARK", label: "DENMARK", value: "DENMARK" },
  { id: "DEPARTMENTAL COLLECTIVITY OF MAYOTTE", label: "DEPARTMENTAL COLLECTIVITY OF MAYOTTE", value: "DEPARTMENTAL COLLECTIVITY OF MAYOTTE" },
  { id: "DHEKELIA", label: "DHEKELIA", value: "DHEKELIA" },
  { id: "DJIBOUTI", label: "DJIBOUTI", value: "DJIBOUTI" },
  { id: "DOMINICA", label: "DOMINICA", value: "DOMINICA" },
  { id: "DOMINICAN REPUBLIC", label: "DOMINICAN REPUBLIC", value: "DOMINICAN REPUBLIC" },
  { id: "EAST TIMOR (TIMORLASTE)", label: "EAST TIMOR (TIMORLASTE)", value: "EAST TIMOR (TIMORLASTE)" },
  { id: "ECUADOR", label: "ECUADOR", value: "ECUADOR" },
  { id: "EGYPT", label: "EGYPT", value: "EGYPT" },
  { id: "ELSALVADOR", label: "ELSALVADOR", value: "ELSALVADOR" },
  { id: "EQUATORIAL GUINEA", label: "EQUATORIAL GUINEA", value: "EQUATORIAL GUINEA" },
  { id: "ERITREA", label: "ERITREA", value: "ERITREA" },
  { id: "ESTONIA", label: "ESTONIA", value: "ESTONIA" },
  { id: "ETHIOPIA", label: "ETHIOPIA", value: "ETHIOPIA" },
  { id: "FALKLAND ISLANDS (ISLAS MALVINAS)", label: "FALKLAND ISLANDS (ISLAS MALVINAS)", value: "FALKLAND ISLANDS (ISLAS MALVINAS)" },
  { id: "FAROE ISLANDS", label: "FAROE ISLANDS", value: "FAROE ISLANDS" },
  { id: "FIJI", label: "FIJI", value: "FIJI" },
  { id: "FINLAND", label: "FINLAND", value: "FINLAND" },
  { id: "FRANCE", label: "FRANCE", value: "FRANCE" },
  { id: "FRENCH GUIANA", label: "FRENCH GUIANA", value: "FRENCH GUIANA" },
  { id: "FRENCH POLYNESIA", label: "FRENCH POLYNESIA", value: "FRENCH POLYNESIA" },
  { id: "FRENCH SOUTHERN ISLANDS", label: "FRENCH SOUTHERN ISLANDS", value: "FRENCH SOUTHERN ISLANDS" },
  { id: "GABON", label: "GABON", value: "GABON" },
  { id: "GEORGIA", label: "GEORGIA", value: "GEORGIA" },
  { id: "GERMANY", label: "GERMANY", value: "GERMANY" },
  { id: "GEURNSEY", label: "GEURNSEY", value: "GEURNSEY" },
  { id: "GHANA", label: "GHANA", value: "GHANA" },
  { id: "GIBRALTAR", label: "GIBRALTAR", value: "GIBRALTAR" },
  { id: "GREECE", label: "GREECE", value: "GREECE" },
  { id: "GREENLAND", label: "GREENLAND", value: "GREENLAND" },
  { id: "GRENADA", label: "GRENADA", value: "GRENADA" },
  { id: "GUADELOUPE", label: "GUADELOUPE", value: "GUADELOUPE" },
  { id: "GUAM", label: "GUAM", value: "GUAM" },
  { id: "GUATEMALA", label: "GUATEMALA", value: "GUATEMALA" },
  { id: "GUERNSEY", label: "GUERNSEY", value: "GUERNSEY" },
  { id: "GUINEA", label: "GUINEA", value: "GUINEA" },
  { id: "GUINEABISSAU", label: "GUINEABISSAU", value: "GUINEABISSAU" },
  { id: "GUYANA", label: "GUYANA", value: "GUYANA" },
  { id: "HAITI", label: "HAITI", value: "HAITI" },
  { id: "HEARD ISLAND AND MCDONALD ISLANDS", label: "HEARD ISLAND AND MCDONALD ISLANDS", value: "HEARD ISLAND AND MCDONALD ISLANDS" },
  { id: "HONDURAS", label: "HONDURAS", value: "HONDURAS" },
  { id: "HONG KONG", label: "HONG KONG", value: "HONG KONG" },
  { id: "HOWLAND ISLAND", label: "HOWLAND ISLAND", value: "HOWLAND ISLAND" },
  { id: "HUNGARY", label: "HUNGARY", value: "HUNGARY" },
  { id: "ICELAND", label: "ICELAND", value: "ICELAND" },
  { id: "INDIA", label: "INDIA", value: "INDIA" },
  { id: "INDONESIA", label: "INDONESIA", value: "INDONESIA" },
  { id: "IRAN", label: "IRAN", value: "IRAN" },
  { id: "IRAQ", label: "IRAQ", value: "IRAQ" },
  { id: "IRELAND", label: "IRELAND", value: "IRELAND" },
  { id: "ISLE OF MAN", label: "ISLE OF MAN", value: "ISLE OF MAN" },
  { id: "ISRAEL", label: "ISRAEL", value: "ISRAEL" },
  { id: "ITALY", label: "ITALY", value: "ITALY" },
  { id: "JAMAICA", label: "JAMAICA", value: "JAMAICA" },
  { id: "JAN MAYEN", label: "JAN MAYEN", value: "JAN MAYEN" },
  { id: "JAPAN", label: "JAPAN", value: "JAPAN" },
  { id: "JARVIS ISLAND", label: "JARVIS ISLAND", value: "JARVIS ISLAND" },
  { id: "JERSEY", label: "JERSEY", value: "JERSEY" },
  { id: "JOHNSTON ATOLL", label: "JOHNSTON ATOLL", value: "JOHNSTON ATOLL" },
  { id: "JORDAN", label: "JORDAN", value: "JORDAN" },
  { id: "KAZAKHSTAN", label: "KAZAKHSTAN", value: "KAZAKHSTAN" },
  { id: "KENYA", label: "KENYA", value: "KENYA" },
  { id: "KINGMAN REEF", label: "KINGMAN REEF", value: "KINGMAN REEF" },
  { id: "KIRIBATI", label: "KIRIBATI", value: "KIRIBATI" },
  { id: "KOREA, NORTH", label: "KOREA, NORTH", value: "KOREA, NORTH" },
  { id: "KOREA, SOUTH", label: "KOREA, SOUTH", value: "KOREA, SOUTH" },
  { id: "KOSOVO", label: "KOSOVO", value: "KOSOVO" },
  { id: "KUWAIT", label: "KUWAIT", value: "KUWAIT" },
  { id: "KYRGYZSTAN", label: "KYRGYZSTAN", value: "KYRGYZSTAN" },
  { id: "LAOS", label: "LAOS", value: "LAOS" },
  { id: "LATVIA", label: "LATVIA", value: "LATVIA" },
  { id: "LEBANON", label: "LEBANON", value: "LEBANON" },
  { id: "LESOTHO", label: "LESOTHO", value: "LESOTHO" },
  { id: "LIBERIA", label: "LIBERIA", value: "LIBERIA" },
  { id: "LIBYA", label: "LIBYA", value: "LIBYA" },
  { id: "LIECHTENSTEIN", label: "LIECHTENSTEIN", value: "LIECHTENSTEIN" },
  { id: "LITHUANIA", label: "LITHUANIA", value: "LITHUANIA" },
  { id: "LUXEMBOURG", label: "LUXEMBOURG", value: "LUXEMBOURG" },
  { id: "MACAU", label: "MACAU", value: "MACAU" },
  { id: "MACEDONIA", label: "MACEDONIA", value: "MACEDONIA" },
  { id: "MADAGASCAR", label: "MADAGASCAR", value: "MADAGASCAR" },
  { id: "MALAWI", label: "MALAWI", value: "MALAWI" },
  { id: "MALAYSIA", label: "MALAYSIA", value: "MALAYSIA" },
  { id: "MALAYSIA (LABUAN)", label: "MALAYSIA (LABUAN)", value: "MALAYSIA (LABUAN)" },
  { id: "MALDIVES", label: "MALDIVES", value: "MALDIVES" },
  { id: "MALI", label: "MALI", value: "MALI" },
  { id: "MALTA", label: "MALTA", value: "MALTA" },
  { id: "MARSHALLISLANDS", label: "MARSHALLISLANDS", value: "MARSHALLISLANDS" },
  { id: "MARTINIQUE", label: "MARTINIQUE", value: "MARTINIQUE" },
  { id: "MAURITANIA", label: "MAURITANIA", value: "MAURITANIA" },
  { id: "MAURITIUS", label: "MAURITIUS", value: "MAURITIUS" },
  { id: "MAYOTTE", label: "MAYOTTE", value: "MAYOTTE" },
  { id: "UNITED MEXICAN STATES", label: "UNITED MEXICAN STATES", value: "UNITED MEXICAN STATES" },
  { id: "MICRONESIA, FEDERATED STATES OF", label: "MICRONESIA, FEDERATED STATES OF", value: "MICRONESIA, FEDERATED STATES OF" },
  { id: "MIDWAY ISLANDS", label: "MIDWAY ISLANDS", value: "MIDWAY ISLANDS" },
  { id: "MOLDOVA", label: "MOLDOVA", value: "MOLDOVA" },
  { id: "MONACO", label: "MONACO", value: "MONACO" },
  { id: "MONGOLIA", label: "MONGOLIA", value: "MONGOLIA" },
  { id: "MONTENEGRO", label: "MONTENEGRO", value: "MONTENEGRO" },
  { id: "MONTSERRAT", label: "MONTSERRAT", value: "MONTSERRAT" },
  { id: "MOROCCO", label: "MOROCCO", value: "MOROCCO" },
  { id: "MOZAMBIQUE", label: "MOZAMBIQUE", value: "MOZAMBIQUE" },
  { id: "MYANMAR (BURMA)", label: "MYANMAR (BURMA)", value: "MYANMAR (BURMA)" },
  { id: "NAMIBIA", label: "NAMIBIA", value: "NAMIBIA" },
  { id: "NAURU", label: "NAURU", value: "NAURU" },
  { id: "NAVASSA ISLAND", label: "NAVASSA ISLAND", value: "NAVASSA ISLAND" },
  { id: "NEPAL", label: "NEPAL", value: "NEPAL" },
  { id: "NETHERLANDS", label: "NETHERLANDS", value: "NETHERLANDS" },
  { id: "NETHERLANDS ANTILLES", label: "NETHERLANDS ANTILLES", value: "NETHERLANDS ANTILLES" },
  { id: "NEW CALEDONIA", label: "NEW CALEDONIA", value: "NEW CALEDONIA" },
  { id: "NEWZEALAND", label: "NEWZEALAND", value: "NEWZEALAND" },
  { id: "NICARAGUA", label: "NICARAGUA", value: "NICARAGUA" },
  { id: "NIGER", label: "NIGER", value: "NIGER" },
  { id: "NIGERIA", label: "NIGERIA", value: "NIGERIA" },
  { id: "NIUE", label: "NIUE", value: "NIUE" },
  { id: "NORFOLK ISLAND", label: "NORFOLK ISLAND", value: "NORFOLK ISLAND" },
  { id: "NORTHERN MARIANA ISLANDS", label: "NORTHERN MARIANA ISLANDS", value: "NORTHERN MARIANA ISLANDS" },
  { id: "NORWAY", label: "NORWAY", value: "NORWAY" },
  { id: "OMAN", label: "OMAN", value: "OMAN" },
  { id: "PAKISTAN", label: "PAKISTAN", value: "PAKISTAN" },
  { id: "PALAU", label: "PALAU", value: "PALAU" },
  { id: "PALMYRA ATOLL", label: "PALMYRA ATOLL", value: "PALMYRA ATOLL" },
  { id: "PANAMA", label: "PANAMA", value: "PANAMA" },
  { id: "PAPUA NEW GUINEA", label: "PAPUA NEW GUINEA", value: "PAPUA NEW GUINEA" },
  { id: "PARACEL ISLANDS", label: "PARACEL ISLANDS", value: "PARACEL ISLANDS" },
  { id: "PARAGUAY", label: "PARAGUAY", value: "PARAGUAY" },
  { id: "PERU", label: "PERU", value: "PERU" },
  { id: "PHILIPPINES", label: "PHILIPPINES", value: "PHILIPPINES" },
  { id: "PITCAIRN ISLANDS", label: "PITCAIRN ISLANDS", value: "PITCAIRN ISLANDS" },
  { id: "PITCAIRN, HENDERSON, DUCIE, AND OENO ISLANDS", label: "PITCAIRN, HENDERSON, DUCIE, AND OENO ISLANDS", value: "PITCAIRN, HENDERSON, DUCIE, AND OENO ISLANDS" },
  { id: "POLAND", label: "POLAND", value: "POLAND" },
  { id: "PORTUGAL", label: "PORTUGAL", value: "PORTUGAL" },
  { id: "PUERTO RICO", label: "PUERTO RICO", value: "PUERTO RICO" },
  { id: "QATAR", label: "QATAR", value: "QATAR" },
  { id: "REUNION", label: "REUNION", value: "REUNION" },
  { id: "ROMANIA", label: "ROMANIA", value: "ROMANIA" },
  { id: "RUSSIA", label: "RUSSIA", value: "RUSSIA" },
  { id: "RWANDA", label: "RWANDA", value: "RWANDA" },
  { id: "SAINT BARTHELEMY", label: "SAINT BARTHELEMY", value: "SAINT BARTHELEMY" },
  { id: "SAINT HELENA", label: "SAINT HELENA", value: "SAINT HELENA" },
  { id: "SAINT KITTS AND NEVIS", label: "SAINT KITTS AND NEVIS", value: "SAINT KITTS AND NEVIS" },
  { id: "SAINT LUCIA", label: "SAINT LUCIA", value: "SAINT LUCIA" },
  { id: "SAINT MARTIN", label: "SAINT MARTIN", value: "SAINT MARTIN" },
  { id: "SAINT PIERRE AND MIQUELON", label: "SAINT PIERRE AND MIQUELON", value: "SAINT PIERRE AND MIQUELON" },
  { id: "SAINT VINCENT AND THE GRENADINES", label: "SAINT VINCENT AND THE GRENADINES", value: "SAINT VINCENT AND THE GRENADINES" },
  { id: "SAMOA", label: "SAMOA", value: "SAMOA" },
  { id: "SANMARINO", label: "SANMARINO", value: "SANMARINO" },
  { id: "SAO TOME AND PRINCIPE", label: "SAO TOME AND PRINCIPE", value: "SAO TOME AND PRINCIPE" },
  { id: "SAUDI ARABIA", label: "SAUDI ARABIA", value: "SAUDI ARABIA" },
  { id: "SENEGAL", label: "SENEGAL", value: "SENEGAL" },
  { id: "SERBIA", label: "SERBIA", value: "SERBIA" },
  { id: "SEYCHELLES", label: "SEYCHELLES", value: "SEYCHELLES" },
  { id: "SIERRA LEONE", label: "SIERRA LEONE", value: "SIERRA LEONE" },
  { id: "SINGAPORE", label: "SINGAPORE", value: "SINGAPORE" },
  { id: "SLOVAKIA", label: "SLOVAKIA", value: "SLOVAKIA" },
  { id: "SLOVENIA", label: "SLOVENIA", value: "SLOVENIA" },
  { id: "SOLOMON ISLANDS", label: "SOLOMON ISLANDS", value: "SOLOMON ISLANDS" },
  { id: "SOMALIA", label: "SOMALIA", value: "SOMALIA" },
  { id: "SOUTH AFRICA", label: "SOUTH AFRICA", value: "SOUTH AFRICA" },
  { id: "SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS", label: "SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS", value: "SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS" },
  { id: "SPRATLY ISLANDS", label: "SPRATLY ISLANDS", value: "SPRATLY ISLANDS" },
  { id: "SPAIN", label: "SPAIN", value: "SPAIN" },
  { id: "SRI LANKA", label: "SRI LANKA", value: "SRI LANKA" },
  { id: "ST. VINCENT & GRENADINES", label: "ST. VINCENT & GRENADINES", value: "ST. VINCENT & GRENADINES" },
  { id: "SUDAN", label: "SUDAN", value: "SUDAN" },
  { id: "SURINAME", label: "SURINAME", value: "SURINAME" },
  { id: "SVALBARD", label: "SVALBARD", value: "SVALBARD" },
  { id: "SWAZILAND", label: "SWAZILAND", value: "SWAZILAND" },
  { id: "SWEDEN", label: "SWEDEN", value: "SWEDEN" },
  { id: "SWITZERLAND", label: "SWITZERLAND", value: "SWITZERLAND" },
  { id: "SYRIA", label: "SYRIA", value: "SYRIA" },
  { id: "TAIWAN", label: "TAIWAN", value: "TAIWAN" },
  { id: "TAJIKISTAN", label: "TAJIKISTAN", value: "TAJIKISTAN" },
  { id: "TANZANIA", label: "TANZANIA", value: "TANZANIA" },
  { id: "TERRITORIAL COLLECTIVITY OF ST. PIERRE & MIQUELON", label: "TERRITORIAL COLLECTIVITY OF ST. PIERRE & MIQUELON", value: "TERRITORIAL COLLECTIVITY OF ST. PIERRE & MIQUELON" },
  { id: "TERRITORY OF AMERICAN SAMOA", label: "TERRITORY OF AMERICAN SAMOA", value: "TERRITORY OF AMERICAN SAMOA" },
  { id: "TERRITORY OF ASHMORE AND CARTIER ISLANDS", label: "TERRITORY OF ASHMORE AND CARTIER ISLANDS", value: "TERRITORY OF ASHMORE AND CARTIER ISLANDS" },
  { id: "TERRITORY OF CHRISTMAS ISLAND", label: "TERRITORY OF CHRISTMAS ISLAND", value: "TERRITORY OF CHRISTMAS ISLAND" },
  { id: "TERRITORY OF COCOS (KEELING) ISLANDS", label: "TERRITORY OF COCOS (KEELING) ISLANDS", value: "TERRITORY OF COCOS (KEELING) ISLANDS" },
  { id: "TERRITORY OF GUAM", label: "TERRITORY OF GUAM", value: "TERRITORY OF GUAM" },
  { id: "TERRITORY OF HEARD ISLAND & MCDONALD ISLANDS", label: "TERRITORY OF HEARD ISLAND & MCDONALD ISLANDS", value: "TERRITORY OF HEARD ISLAND & MCDONALD ISLANDS" },
  { id: "TERRITORY OF NORFOLK ISLAND", label: "TERRITORY OF NORFOLK ISLAND", value: "TERRITORY OF NORFOLK ISLAND" },
  { id: "THAILAND", label: "THAILAND", value: "THAILAND" },
  { id: "THE BAHAMAS", label: "THE BAHAMAS", value: "THE BAHAMAS" },
  { id: "THE GAMBIA", label: "THE GAMBIA", value: "THE GAMBIA" },
  { id: "TOGO", label: "TOGO", value: "TOGO" },
  { id: "TOKELAU", label: "TOKELAU", value: "TOKELAU" },
  { id: "TONGA", label: "TONGA", value: "TONGA" },
  { id: "TRINIDAD AND TOBAGO", label: "TRINIDAD AND TOBAGO", value: "TRINIDAD AND TOBAGO" },
  { id: "TUNISIA", label: "TUNISIA", value: "TUNISIA" },
  { id: "TURKEY", label: "TURKEY", value: "TURKEY" },
  { id: "TURKMENISTAN", label: "TURKMENISTAN", value: "TURKMENISTAN" },
  { id: "TURKS AND CAICOS ISLANDS", label: "TURKS AND CAICOS ISLANDS", value: "TURKS AND CAICOS ISLANDS" },
  { id: "TUVALU", label: "TUVALU", value: "TUVALU" },
  { id: "UGANDA", label: "UGANDA", value: "UGANDA" },
  { id: "UKRAINE", label: "UKRAINE", value: "UKRAINE" },
  { id: "UNITED ARAB EMIRATES", label: "UNITED ARAB EMIRATES", value: "UNITED ARAB EMIRATES" },
  { id: "UNITED KINGDOM", label: "UNITED KINGDOM", value: "UNITED KINGDOM" },
  { id: "UNITED STATES VIRGIN ISLANDS", label: "UNITED STATES VIRGIN ISLANDS", value: "UNITED STATES VIRGIN ISLANDS" },
  { id: "UNITED STATES OF AMERICA", label: "UNITED STATES OF AMERICA", value: "UNITED STATES OF AMERICA" },
  { id: "URUGUAY", label: "URUGUAY", value: "URUGUAY" },
  { id: "UZBEKISTAN", label: "UZBEKISTAN", value: "UZBEKISTAN" },
  { id: "VANUATU", label: "VANUATU", value: "VANUATU" },
  { id: "VATICAN CITY (HOLYSEE)", label: "VATICAN CITY (HOLYSEE)", value: "VATICAN CITY (HOLYSEE)" },
  { id: "VENEZUELA", label: "VENEZUELA", value: "VENEZUELA" },
  { id: "VIETNAM", label: "VIETNAM", value: "VIETNAM" },
  { id: "VIRGIN ISLANDS, BRITISH", label: "VIRGIN ISLANDS, BRITISH", value: "VIRGIN ISLANDS, BRITISH" },
  { id: "VIRGIN ISLANDS, U.S.", label: "VIRGIN ISLANDS, U.S.", value: "VIRGIN ISLANDS, U.S." },
  { id: "WAKE ISLAND", label: "WAKE ISLAND", value: "WAKE ISLAND" },
  { id: "WALLIS AND FUTUNA", label: "WALLIS AND FUTUNA", value: "WALLIS AND FUTUNA" },
  { id: "WESTERN SAHARA", label: "WESTERN SAHARA", value: "WESTERN SAHARA" },
  { id: "YEMEN", label: "YEMEN", value: "YEMEN" },
  { id: "ZAMBIA", label: "ZAMBIA", value: "ZAMBIA" },
  { id: "ZIMBABWE", label: "ZIMBABWE", value: "ZIMBABWE" },
  { id: "COMBODIA", label: "COMBODIA", value: "COMBODIA" },
  { id: "CONGO", label: "CONGO", value: "CONGO" },
  { id: "IVORY COAST", label: "IVORY COAST", value: "IVORY COAST" },
  { id: "WEST INDIES", label: "WEST INDIES", value: "WEST INDIES" },
  { id: "BRITISH VIRGIN ISLANDS", label: "BRITISH VIRGIN ISLANDS", value: "BRITISH VIRGIN ISLANDS" }
];


export const VENDOR_STATUS_OPTIONS = [
  { id: "company", value: "Company", label: "Company" },
  { id: "other", value: "Other than company", label: "Other than company" },
];

export const RESIDENTIAL_STATUS_OPTIONS = [
  { id: "r", value: "R", label: "R" },
  { id: "nr", value: "NR", label: "NR" },
];

export const TAXATION_REGIME_OPTIONS = [
  { id: "yes", value: "Yes", label: "Yes" },
  { id: "no", value: "No", label: "No" },
];

export const PAN_AADHAR_OPTIONS = [
  { id: "yes", value: "Yes", label: "Yes" },
  { id: "no", value: "No", label: "No" },
];


export const GROSSING_UP_OPTIONS = [
  { id: 'yes', value: 'Yes', label: 'Yes' },
  { id: 'no', value: 'No', label: 'No', defaultValue: true },
]

export const NATURE_OF_REMITTANCE_OPTIONS = [
  { id: "16", value: "DIVIDEND", label: "DIVIDEND" },
  { id: "21", value: "FEES FOR TECHNICAL SERVICES/ FEES FOR INCLUDED SERVICES", label: "FEES FOR TECHNICAL SERVICES/ FEES FOR INCLUDED SERVICES" },
  { id: "27", value: "INTEREST PAYMENT", label: "INTEREST PAYMENT" },
  { id: "28", value: "INVESTMENT INCOME", label: "INVESTMENT INCOME" },
  { id: "31", value: "LONG TERM CAPITAL GAINS (Others)", label: "LONG TERM CAPITAL GAINS (Others)" },
  { id: "66", value: "Long Term Capital Gain u/s 115E in case of Non Resident Indian Citizen", label: "Long Term Capital Gain u/s 115E in case of Non Resident Indian Citizen" },
  { id: "67", value: 'Long Term Capital Gain u/s 112(1)(c)(iii)', label: 'Long Term Capital Gain u/s 112(1)(c)(iii)' },
  { id: "68", value: "Long Term Capital Gain u/s 112", label: "Long Term Capital Gain u/s 112" },
  { id: "69", value: "Long Term Capital Gain u/s 112A", label: "Long Term Capital Gain u/s 112A" },
  { id: "49", value: "ROYALTY", label: "ROYALTY" },
  { id: "52", value: "SHORT TERM CAPITAL GAINS", label: "SHORT TERM CAPITAL GAINS" },
  { id: "70", value: "SHORT TERM CAPITAL GAINS U/S 111A", label: "SHORT TERM CAPITAL GAINS U/S 111A" },
  {
    id: "99", value: "OTHER INCOME / OTHER (NOT IN THE NATURE OF INCOME)",
    label: "OTHER INCOME / OTHER (NOT IN THE NATURE OF INCOME)",
    defaultValue: true
  }
];


export const TDS_RATE_BELONGS_TO_OPTIONS = [
  { id: 'itAct', value: 'A', label: 'A' },
  { id: 'dtaa', value: 'B', label: 'B', defaultValue: true },
]

export const TRANSACTION_CATEGORY_OPTIONS = [
  { id: 'invoice', value: 'INVOICE', label: 'Invoice', defaultValue: true },
  { id: 'provision', value: 'PROVISION', label: 'Provision' },
  { id: 'advance', value: 'ADVANCE', label: 'Advance' },
  { id: 'credit_note', value: 'CREDIT_NOTE', label: 'Credit Note' },
  { id: 'debit_note', value: 'DEBIT_NOTE', label: 'Debit Note' },
  { id: 'reversal', value: 'REVERSAL', label: 'Reversal' },
  { id: 'others', value: 'OTHERS', label: 'Others' },

]

export const REMARKS_OPTIONS = [
  { id: 'A', value: 'A', label: 'A' },
  { id: 'B', value: 'B', label: 'B' },
  { id: 'C', value: 'C', label: 'C' },
  { id: 'T', value: 'T', label: 'T' },
  { id: 'Y', value: 'Y', label: 'Y' },
  { id: 'S', value: 'S', label: 'S' },
  { id: 'Z', value: 'Z', label: 'Z' },
  { id: 'R', value: 'R', label: 'R' },
  { id: 'N', value: 'N', label: 'N' },
  { id: 'D', value: 'D', label: 'D' },
  { id: 'O', value: 'O', label: 'O' },
  { id: 'M', value: 'M', label: 'M' },
  { id: 'E', value: 'E', label: 'E' },
  { id: 'P', value: 'P', label: 'P' },
  { id: 'Q', value: 'Q', label: 'Q' },
  { id: 'U', value: 'U', label: 'U' },
];

export const MONTH_OPTIONS = [
  { id: 1, value: 1, label: "January" },
  { id: 2, value: 2, label: "February" },
  { id: 3, value: 3, label: "March" },
  { id: 4, value: 4, label: "April" },
  { id: 5, value: 5, label: "May" },
  { id: 6, value: 6, label: "June" },
  { id: 7, value: 7, label: "July" },
  { id: 8, value: 8, label: "August" },
  { id: 9, value: 9, label: "September" },
  { id: 10, value: 10, label: "October" },
  { id: 11, value: 11, label: "November" },
  { id: 12, value: 12, label: "December" },
];

export const getMonthLabel = (monthValue) => {
  const month = MONTH_OPTIONS.find(m => m.value === Number(monthValue));
  return month ? month.label : '';
};



// Utility function to check and format numbers in Indian style
export function formatIndianNumber(value, isFormatted = true) {
  if (value === null || value === undefined || value === '' || !isFormatted)
    return value;

  // Remove existing commas
  const cleanedValue = value.toString().replace(/,/g, '');

  // Regex to check if value is a valid number (integer or decimal, optional minus)
  if (/^-?\d+(\.\d+)?$/.test(cleanedValue)) {
    const isNegative = cleanedValue.startsWith('-');
    let numStr = isNegative ? cleanedValue.slice(1) : cleanedValue; // remove '-'

    let [integerPart, decimalPart] = numStr.split('.');

    // Format integer part in Indian number system
    let lastThree = integerPart.slice(-3);
    let otherDigits = integerPart.slice(0, -3);

    if (otherDigits !== '') lastThree = ',' + lastThree;
    let formattedInteger =
      otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

    let formatted = formattedInteger;
    if (decimalPart) formatted += '.' + decimalPart;

    // Add negative sign back in front (no comma after it)
    return isNegative ? `-${formatted}` : formatted;
  }

  return value;
}


export function sanitizeForLog(input) {
  try {
    let str =
      typeof input === 'string' ? input : JSON.stringify(input, null, 0);

    // Remove CR/LF to prevent log forging (CWE-117)
    str = str.replace(/[\r\n]+/g, ' ');

    // Escape potentially dangerous characters
    str = str.replace(/[<>&'"]/g, (ch) =>
    ({
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      "'": '&#39;',
      '"': '&quot;',
    }[ch])
    );

    // Trim excess whitespace
    return str.trim();
  } catch {
    return '[Unserializable input]';
  }
}

/**
 * Safe logger that sanitizes all arguments before writing to console.
 * Breaks Veracode's taint-propagation chain for CWE-117 by ensuring
 * no unsanitized external input reaches console.error / console.log.
 */
export const safeLog = Object.freeze({
  error(...args) {
    const cleaned = args.map(a => sanitizeForLog(a))
    // eslint-disable-next-line no-console
    console.error(...cleaned)
  },
  warn(...args) {
    const cleaned = args.map(a => sanitizeForLog(a))
    // eslint-disable-next-line no-console
    console.warn(...cleaned)
  },
  log(...args) {
    const cleaned = args.map(a => sanitizeForLog(a))
    // eslint-disable-next-line no-console
    console.log(...cleaned)
  },
})


export function sanitizeText(text) {
  if (typeof text !== 'string') return '';
  // Strip HTML/script tags and control characters
  return text.replace(/[<>]/g, '').replace(/[\r\n]/g, '');
}

// utils/safeRedirect.js
export function safeRedirect(url) {
  // Validate URL to prevent XSS attacks (CWE-80)
  try {
    const parsedUrl = new URL(url, window.location.origin);
    const allowedProtocols = ['http:', 'https:'];

    if (!allowedProtocols.includes(parsedUrl.protocol)) {
      console.error('Invalid URL protocol. Only http and https are allowed.');
      return;
    }

    const link = document.createElement('a');
    link.href = parsedUrl.href;
    link.target = '_self';
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Invalid URL provided to safeRedirect:', error);
  }
}

/**
 * Safely update the browser URL via pushState after validating the URL
 * is same-origin and contains no script-injectable content (CWE-80).
 *
 * @param {string} path - A relative path or full same-origin URL to push.
 * @returns {boolean} true if pushState succeeded, false if the URL was rejected.
 */
export function safePushState(path) {
  // Build an absolute URL so we can inspect its components
  const resolved = new URL(path, window.location.origin);

  // Block any protocol other than http/https (prevents javascript:, data:, etc.)
  if (resolved.protocol !== 'http:' && resolved.protocol !== 'https:') {
    return false;
  }

  // Enforce same-origin — reject any attempt to push a cross-origin URL
  if (resolved.origin !== window.location.origin) {
    return false;
  }

  // Reject URLs whose href contains characters commonly used in XSS payloads
  // Allow only unreserved + standard URL characters
  if (!/^[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]+$/.test(resolved.href)) {
    return false;
  }

  window.history.pushState({}, '', resolved.href);
  return true;
}

export function removeIndianNumberFormatting(value) {
  if (value === null || value === undefined || value === '') return value;

  // Convert to string and remove all commas
  const cleanedValue = value.toString().replace(/,/g, '');

  // If it's a valid number string, return numeric type, else return as is
  return /^-?\d+(\.\d+)?$/.test(cleanedValue) ? cleanedValue : value;
}
